import { render, staticRenderFns } from "./CalendarEntry.vue?vue&type=template&id=ea253898&scoped=true"
import script from "./CalendarEntry.vue?vue&type=script&lang=js"
export * from "./CalendarEntry.vue?vue&type=script&lang=js"
import style0 from "./CalendarEntry.vue?vue&type=style&index=0&id=ea253898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea253898",
  null
  
)

export default component.exports